import Vue from 'vue'
import App from './App.vue'
import router from './config/router'
import store from './store'
import vuetify from './config/vuetify'
import {
  setupComponents
} from './config/components'
import axios from './config/axios'
import signalr from './config/signalr'
import filters from './config/filters'
import jsonExcel from "vue-json-excel";
import './registerServiceWorker'
// config/axios экспортирует строку 'axios', поэтому baseURL берём из пакета напрямую (см. CLAUDE.md, Gotchas)
import axiosLib from 'axios'
import analytics from './utils/analytics'


Vue.component("downloadExcel", jsonExcel);
Vue.config.productionTip = false

setupComponents(Vue)

// аналитика: session id и обработчики ухода со страницы; page_view шлёт router.afterEach
analytics.init({
  getToken: () => store.getters.ACCESS_TOKEN,
  baseURL: axiosLib.defaults.baseURL
})

new Vue({
  router,
  store,
  signalr,
  vuetify,
  filters,
  axios,
  render: h => h(App)
}).$mount('#app')